export const mockSwgyHeaders = {
    tid: "ce44bb9e-69d7-4c69-a0b7-4bf40a597dc2",
    sid: "59314f55-5e8a-456d-8091-7b29f788df1c",
    deviceId: "3d1d75c3-2656-41d3-b170-d618d89a846a",
    token: "f4d2270c-30bd-4878-a5c9-b8c8d9bfe3e1cb3cf499-3d4c-43bb-aa69-f9b20bb89f00",
    analyticsPlatform: "an",
    platform: "Swiggy-Android",
    "version-code": "718",
    bottomOffset: "0",
    statusBarHeight: "0",
    lat: "23.45",
    lng: "24.45",
};
